<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';

const { setReserveType } = useSearchFormStore();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/train-ticket',
        },
    ],
});

onMounted(() => setReserveType(ReserveType.Train));
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط قطار', link: '$routePath' },
    ]),
});
</script>

<template>
    <InformationContainer />
</template>
